<template>
  <div class="item rank">
    <div class="top">
      <div class="left">
        <div class="icon"></div>
        <div class="title"><span>Ranking</span></div>
      </div>
      <div class="actions">
        <div class="select">
          <span>{{ type }}&nbsp;<i class="fa-solid fa-angle-down"></i></span>
          <div class="boxSelect">
            <div class="option" @click="() => {getRank(3, 'comments'); type = 'Comentários'}">Comentários</div>
            <div class="option" @click="() => {getRank(3, 'locs'); type = 'Locutores'}">Locutores</div>
            <div class="option" @click="() => {getRank(3, 'prom'); type = 'Promotores'}">Promotores</div>
            <div class="option" @click="() => {getRank(3, 'mark'); type = 'Marketing'}">Marketing</div>
            <div class="option" @click="() => {getRank(3, 'prog'); type = 'Programadores'}">Programadores</div>
            <div class="option" @click="() => {getRank(3, 'const'); type = 'Construtores'}">Construtores</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="ranking">
        <template v-if="loading">
          <div class="box rank2"><Sk w="60px" h="90px" rounded="rounded-xl" extra="mx-auto" /></div>
          <div class="box rank1"><Sk w="60px" h="110px" rounded="rounded-xl" extra="mx-auto" /></div>
          <div class="box rank3"><Sk w="60px" h="80px" rounded="rounded-xl" extra="mx-auto" /></div>
        </template>
        <template v-else>
        <div class="box rank2" v-for="(r, index) in rank2" :key="index">
          <MyTip :title="r.user+'<br>'+r.count" top="-90%" line="24px" />
          <div class="avatar" @click="() => {showP = true; perfilName = r.user}"
               :style="{backgroundImage: `url('${avatarUrl(r.user, { headonly: 0 })}')`}"></div>
        </div>
        <div class="box rank1" v-for="(r, index) in rank1" :key="index">
          <MyTip :title="r.user+'<br>'+r.count" top="-90%" line="24px" />
          <div class="avatar" @click="() => {showP = true; perfilName = r.user}"
               :style="{backgroundImage: `url('${avatarUrl(r.user, { head_direction: 3, headonly: 0 })}')`}"></div>
        </div>
        <div class="box rank3" v-for="(r, index) in rank3" :key="index">
          <MyTip :title="r.user+'<br>'+r.count" top="-90%" line="24px" />
          <div class="avatar" @click="() => {showP = true; perfilName = r.user}"
               :style="{backgroundImage: `url('${avatarUrl(r.user, { action: 'std,crr=', direction: 4, head_direction: 3, img_format: '', dance: '', effect: '', frame_num: 30 })}')`}"></div>
        </div>
        </template>
      </div>
      <RouterLink :to="{path: '/pagina/ranking', name: 'Ranking'}">
        <div class="btn">Ver ranking completo</div>
      </RouterLink>
    </div>
    <Transition name="slide-fade">
      <ItemPerfil v-if="showP" @close="showP = false" :user="perfilName" />
    </Transition>
  </div>
</template>

<script setup>

import { getRank as apiGetRank, avatarUrl } from '@/services/api.js'
import MyTip from '@/components/usefulness/tooltip.vue'
import ItemPerfil from '@/components/modals/perfil.vue'
import Sk from '@/components/usefulness/Sk.vue'
import { onMounted, ref } from 'vue'

let rank1 = ref([])
let rank2 = ref([])
let rank3 = ref([])
let loading = ref(true)
let type = ref('Comentários')
let perfilName = ref('')
let showP = ref(false)

async function getRank(limit, rankType = '', random = false) {
  try {
    const data = await apiGetRank(limit, rankType)

    if (random && (!data?.rankTop?.length || data?.rankTop?.length < 3)) {
      return false
    }

    rank1.value = data?.rankTop?.[0] ?? []
    rank2.value = data?.rankTop?.[1] ?? []
    rank3.value = data?.rankTop?.[2] ?? []
    return true
  } catch {
    return false
  } finally {
    loading.value = false
  }
}

async function randomRanking() {
  const options = [
    { value: '', label: 'Comentários' },
    { value: 'locs', label: 'Locutores' },
    { value: 'prom', label: 'Promotores' },
    { value: 'mark', label: 'Marketing' },
    { value: 'prog', label: 'Programadores' },
    { value: 'const', label: 'Construtores' },
  ].sort(() => Math.random() - 0.5)

  for (const option of options) {
    const ok = await getRank(3, option.value, true)
    if (ok) {
      type.value = option.label
      return
    }
  }
}

onMounted(() => randomRanking())

</script>

<style scoped>

.rank {
  position: relative;
  width: 100%;
  @apply pr-2;
}

.rank .top .icon {
  background-color: #F7BD15;
  background-position: 5px -66px;
}

.rank .top .select {
  width: 120px;
  height: 34px;
  border-radius: 12px;
  color: #112535;
  font-size: 14px;
}

.rank .top .select span {
  width: 100%;
  height: 100%;
  float: left;
  line-height: 34px;
  text-align: center;
  background-color: #D7E0E9;
  border-radius: 12px;
}

.rank .top .select .boxSelect {
  position: relative;
  float: left;
  width: 100%;
  height: auto;
  background-color: #C8D2DC;
  border-radius: 12px;
  opacity: 0;
  visibility: hidden;
  transition: all .3s ease .1s;
  z-index: 99;
}

.rank .top .select:hover .boxSelect {
  opacity: 1;
  visibility: visible;
}

.rank .top .select .boxSelect div {
  float: left;
  width: 100%;
  height: 32px;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  cursor: pointer;
}

.rank .top .select .boxSelect div:hover {
  font-weight: 600;
}

.rank .content {
  position: relative;
  width: 100%;
  float: left;
  height: 282px;
  background-color: #E6EBF1;
  border-radius: 12px;
}

.rank .content .ranking {
  position: relative;
  float: left;
  width: 100%;
  height: calc(100% - 54px);
  display: flex;
  justify-content: space-evenly;
}

.rank .content .box {
  position: relative;
  width: 66px;
  height: 133px;
  background-repeat: no-repeat;
}

.rank .content .box.rank2 {
  background-image: url('../../assets/rank_2.png');
  margin-top: 131px;
}

.rank .content .box.rank1 {
  background-image: url('../../assets/rank_1.png');
  margin-top: 93px;
}

.rank .content .box.rank3 {
  background-image: url('../../assets/rank_3.png');
  margin-top: 143px;
}

.rank .content .box .avatar {
  float: left;
  width: 100%;
  height: 130px;
  margin: -96px 0 0 -3px;
  background-repeat: no-repeat;
  background-position: center;
}

/*noinspection ALL*/
.rank .content .btn {
  width: 100%;
  float: left;
  height: 56px;
  border-radius: 0 0 12px 12px;
  background-color: var(--color2);
  text-align: center;
  line-height: 54px;
  font-size: 14px;
  font-weight: 800;
  color: #fff;
}

</style>
